module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/advice-3d8468d7c79466373f1973d447100078.webp";